module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assign access"},"da":{"title":"Tildel adgang"}}')
  delete Component.options._Ctor
}
